import React from "react";
import {Observer} from "web-vcore";
import {BaseComponent} from "react-vextensions";
import {liveSkin} from "../../Utils/Styles/StyleManager.js";
import {observer_mgl} from "mobx-graphlink";

// This class is defined in user-project rather than web-vcore, so that it can use @Observer (ie. evaluate mobx-fields) while determining its final css.
export const RootStyles = observer_mgl({bailHandler_opts: {loadingUI: ()=>null} as any}, () => {
	const skin = liveSkin;
	React.useEffect(() => {
		skin.CSSHooks_Freeform();
	}, []);

	return (
		<style>{`
			${skin.RawCSS_ApplyScalarsAndStyles()}
			${skin.RawCSS_Freeform()}
		`}</style>
	);
});
